import { createContext, useContext, useState, useEffect } from "react";
import API from "../lib/api";

const SiteSettingsContext = createContext({ siteTitle: "CrystoBag" });

export function SiteSettingsProvider({ children }) {
  const [siteTitle, setSiteTitle] = useState("CrystoBag");

  useEffect(() => {
    API.get("/site-settings").then(r => {
      if (r.data.site_title) setSiteTitle(r.data.site_title);
    }).catch(() => {});
  }, []);

  return (
    <SiteSettingsContext.Provider value={{ siteTitle }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export const useSiteSettings = () => useContext(SiteSettingsContext);
